/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
import { C as Content, d as defineCustomElement$1 } from './p-DGOrLIyS.js';

const IonContent = Content;
const defineCustomElement = defineCustomElement$1;

export { IonContent, defineCustomElement };
